/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function (Class) {
	'use strict';

	var ServiceBase = Class.extend({

		init: function() {
			ServiceBase.inherited('init', this, arguments);

			this._requestIdTracking = {};
		},

		getRequestId: function(querySender) {
			return querySender ? this._requestIdTracking[querySender] || 0 : 0;
		},

		updateRequestId: function(querySender) {
			return querySender ? this._requestIdTracking[querySender] = this.getRequestId(querySender) + 1 : 0;
		},

		isActiveRequest: function(requestId, querySender) {
			return requestId === this.getRequestId(querySender);
		}
	});

	return ServiceBase;
});
